import React from 'react'
import { FaStar } from 'react-icons/fa';

import {GoVerified} from "react-icons/go"
function Servivevideo() {
    const movie = {
        imageSrc: 'data:image/jpeg;base64,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',
        altText: 'Movie',
        title: 'Service Name',
        description: 'Click the button to watch on Jetflix app.',
        
      };
  return (
    <>

<div className="flex flex-col gap-4 mb-8">
<h1 className="font-all font-bold text-center mx-auto text-[21px] lg:mt-[27px]">Services For You</h1>
     <div className="flex  shadow-xl w-[140vh] rounded-lg">
      <figure>
        <img className='w-[280px] rounded-lg h-[251px]' src={movie.imageSrc} alt={movie.altText} />
      </figure>
      <div className="card-body">
        <h2 className="font-bold font-all lg:mt-[30px] lg:ml-12 lg:text-[17px]">{movie.title}</h2>

     <div className="flex flex-row items-center lg:ml-[2rem] lg:mt-[1rem] lg:gap-[15px]">
    <div className=" badge bg-[#E98F92] p-[5px] rounded-md"><h4 className='font-semibold flex flex-row items-center text-[#263238]'>Verified <span><GoVerified/></span></h4></div>
     
    <div className="flex items-center border-x-2 border-black px-3">
      <FaStar className="w-5 h-5 text-yellow-300" />
      <FaStar className="w-5 h-5 text-yellow-300" />
      <FaStar className="w-5 h-5 text-yellow-300" />
      <FaStar className="w-5 h-5 text-yellow-300" />
      <FaStar className="w-5 h-5 text-gray-300 dark:text-gray-500" />
      <p className="ml-2 text-sm font-medium text-[#263238] dark:text-gray-400">4/5</p>
    </div>

    <p className='font-bold font-all decoration-solid text-[#263238]'>Reviews</p>
     </div>

     <h5 className='font-all text-[#263238] lg:p-[24px] font-semibold'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint molestiae praesentium expedita quos quo dolorum id velit deleniti, reiciendis quaerat.</h5>
     
      </div>
    </div>
   

    <div className="flex  shadow-xl w-[140vh] rounded-lg">
      <figure>
        <img className='w-[280px] rounded-lg h-[251px]' src={movie.imageSrc} alt={movie.altText} />
      </figure>
      <div className="card-body">
        <h2 className="font-bold font-all lg:mt-[30px] lg:ml-12 lg:text-[17px]">{movie.title}</h2>

     <div className="flex flex-row items-center lg:ml-[2rem] lg:mt-[1rem] lg:gap-[15px]">
    <div className=" badge bg-[#E98F92] p-[5px] rounded-md"><h4 className='font-semibold flex flex-row items-center text-[#263238]'>Verified <span><GoVerified/></span></h4></div>
     
    <div className="flex items-center border-x-2 border-black px-3">
      <FaStar className="w-5 h-5 text-yellow-300" />
      <FaStar className="w-5 h-5 text-yellow-300" />
      <FaStar className="w-5 h-5 text-yellow-300" />
      <FaStar className="w-5 h-5 text-yellow-300" />
      <FaStar className="w-5 h-5 text-gray-300 dark:text-gray-500" />
      <p className="ml-2 text-sm font-medium text-[#263238] dark:text-gray-400">4/5</p>
    </div>

    <p className='font-bold font-all decoration-solid text-[#263238]'>Reviews</p>
     </div>

     <h5 className='font-all text-[#263238] lg:p-[24px] font-semibold'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint molestiae praesentium expedita quos quo dolorum id velit deleniti, reiciendis quaerat.</h5>
     
      </div>
    </div>

    </div>
    </>
  )
}

export default Servivevideo
